import { Component, inject, OnDestroy } from '@angular/core';

import { ButtonModule, DialogRef, IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { ExchangeStore } from '@kr/components/exchange/exchange.store';

@Component({
  selector: 'kr-exchange-failed',
  imports: [IconModule, TranslateModule, ButtonModule],
  templateUrl: './exchange-failed.component.html',
  styleUrl: './exchange-failed.component.scss',
})
export class ExchangeFailedComponent implements OnDestroy {
  readonly store = inject(ExchangeStore);
  readonly dialogRef = inject(DialogRef);

  isPageOpened = location.pathname.includes('exchange');

  ngOnDestroy(): void {
    this.store.clearExchange();
  }
}
